// Neue E-Mail aus Listen und Kontaktkarten: das Brief-Symbol löst EMAIL_VERFASSEN aus, der App-Rahmen nimmt das
// Ereignis ab (preventDefault) und öffnet die Lead-Seite mit dem E-Mail-Komposer des CRM, Empfänger vorbelegt.
// Nur wenn niemand abnimmt (z. B. außerhalb des App-Rahmens), bleibt der mailto-Link als Rückfall.
// Der Auftrag reist im Router-Zustand (nicht in der Adresse), damit keine Mailadressen in der URL stehen.

export const EMAIL_VERFASSEN = "crm:email-verfassen";

export interface EmailVerfassenDetail {
  leadId: string;
  contactId: string | null;
  an: string;
  leadName: string | null;
}

/** Löst das Ereignis aus. true: der CRM-Komposer übernimmt, der mailto-Link darf nicht mehr öffnen. */
export function emailVerfassen(detail: EmailVerfassenDetail): boolean {
  return !window.dispatchEvent(new CustomEvent<EmailVerfassenDetail>(EMAIL_VERFASSEN, { detail, cancelable: true }));
}

/** Auftrag an die Lead-Seite im Router-Zustand: Komposer öffnen, Empfänger vorbelegen. */
export interface SchreibAuftrag {
  schreiben: "email";
  an: string | null;
  kontakt: string | null;
}

export function schreibAuftragLesen(state: unknown): SchreibAuftrag | null {
  if (!state || typeof state !== "object") return null;
  const s = state as Partial<SchreibAuftrag>;
  if (s.schreiben !== "email") return null;
  return { schreiben: "email", an: typeof s.an === "string" ? s.an : null, kontakt: typeof s.kontakt === "string" ? s.kontakt : null };
}

// SMS aus der Kontaktkarte: das SMS-Symbol löst SMS_VERFASSEN aus, die Lead-Seite nimmt das Ereignis ab (preventDefault)
// und öffnet den SMS-Komposer mit diesem Kontakt (und dessen Mobilnummer) als Empfänger. Nimmt niemand ab (die
// Lead-Seite ist nicht offen), bleibt es beim Rückfall der Karte.
export const SMS_VERFASSEN = "crm:sms-verfassen";

export interface SmsVerfassenDetail {
  leadId: string;
  contactId: string;
}

/** Löst das Ereignis aus. true: die Lead-Seite hat es übernommen. */
export function smsVerfassen(detail: SmsVerfassenDetail): boolean {
  return !window.dispatchEvent(new CustomEvent<SmsVerfassenDetail>(SMS_VERFASSEN, { detail, cancelable: true }));
}
